import { defineStore } from 'pinia';
import type { IEditorState } from '../types/store-states.types';
import { useConfigStore } from './config.store';

export const useEditorStore = defineStore('au-editor', {
  state: () => ({
    stateId: null,
    proofs: null,
    chunks: null,
    preview: null,
    dataset: null,
    isRestore: false,
  } as IEditorState),

  getters: {
    getStateId: (state) => state.stateId,
    getAdaptiveStateId: (state) => {
      const configStore = useConfigStore();
      const possibleStateId = state.stateId || configStore.getProductDefinition;
      if (!possibleStateId) {
        return null;
      } else {
        return (Array.isArray(possibleStateId)) ? possibleStateId[0] : possibleStateId;
      }
    },
    getProofs: (state) => state.proofs,
    getPreview: (state) => state.preview,
    getDataset: (state) => state.dataset,
    getCountRowsVdp: (state) => {
      if (!state.dataset) {
        return 0;
      }
      let count = 0;
      state.dataset.forEach((sheet) => {
        sheet.rows.forEach((_) => {
          count += 1;
        });
      });
      return count;
    },
    getChunks: (state) => state.chunks,
    getIsRestore: (state) => state.isRestore,
  },

  actions: {
    updateStateId(stateId: IEditorState['stateId']): void {
      const urlReplace = new URL(window.location.href);
      urlReplace.searchParams.set('stateId', String(stateId));
      history.replaceState(null, '', urlReplace.search);
      this.stateId = stateId;
    },

    setProofs(proofs: IEditorState['proofs']): void {
      this.proofs = proofs;
      this.chunks = null;
    },

    addProofChunk(proofChunk: IEditorState['proofs'], total: number): void {
      if (!this.chunks) {
        this.chunks = {
          loadedCount: 0,
          totalCount: total,
          items: [],
        };
      } else {
        if (proofChunk) {
          this.chunks.items = [...this.chunks.items, ...proofChunk];
          this.chunks.loadedCount += proofChunk.length;
        }
      }
    },

    setPreview(preview: IEditorState['preview']): void {
      this.preview = preview;
    },

    setDataSet(dataset: IEditorState['dataset']): void {
      this.dataset = dataset;
    },

    setRestoreState(value: IEditorState['isRestore']): void {
      this.isRestore = value;
    },
  },
});
